export default (sectionId, offset) =>
  new Promise((resolve, reject) => {
    window.axios
      .post(`${process.env.VUE_APP_API_ADMIN_LOCATION}homefeed/section/${sectionId}/move`, {
        offset: Number(offset),
      })
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
